import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  ListGroup,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faShieldAlt,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { COLOR_APP } from "../../constants";
import { useToasts } from "react-toast-notifications";
import EmptyComponent from "../../components/EmptyComponent";
import "react-spring-bottom-sheet/dist/style.css";
import { GET_USER_CONFIRMS } from "../../graphql/userConfirm/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_SETTINGS } from "../../graphql/setting/query";
import { UPDATE_USER_CONFIRM } from "../../graphql/userConfirm/mutation";
import UserCFMessenger from "./UserCFMessenger";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import "./UserCF.css";
import LoadingSpinner from "../../components/LoadingSpinner";
import _ from "lodash";

function UsersCF() {
  const { height, width } = useWindowDimensions();
  const { addToast } = useToasts();
  const [userList, setUserList] = useState([]);
  const [showUpdateTags, setShowUpdateTags] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [settingTagName, setSettingTagName] = useState([]);
  const [settingTagColor, setSettingTagColor] = useState([]);
  const [enrollTagName, setEnrollTagName] = useState([]);
  const [enrollTagColor, setEnrollTagColor] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [showMessengerModal, setShowMessengerModal] = useState(false);
  const [name, setName] = useState();
  const [status, setStatus] = useState(false);

  let SHOP_ID = localStorage.getItem("SHOP");

  const [getUserConfirmData, { data: userConfirmData, loading: loadingQueryUser }] = useLazyQuery(
    GET_USER_CONFIRMS,
    { fetchPolicy: "cache-and-network" }
  );
  const [getShopTagSetting, { data: shopTagSetting }] = useLazyQuery(
    GET_SETTINGS,
    { fetchPolicy: "cache-and-network" }
  );

  const [updateUserConfirm, { loading: loadingUpdateUserConfirm }] = useMutation(UPDATE_USER_CONFIRM);

  useEffect(() => {
    _getShopTag();
    _getUserConfirms();
  }, [name, status]);

  useEffect(() => {
    if (userConfirmData) {
      setUserList(userConfirmData?.userConfirms?.data);
    }
  }, [userConfirmData]);
  
  useEffect(() => {
    if (
      shopTagSetting?.settings?.data[0] &&
      shopTagSetting?.settings?.data[0].tags
    ) {
      const raw = shopTagSetting?.settings?.data[0].tags;

      let parsed = null;
      if (typeof raw === 'string') {
        try {
          parsed = JSON.parse(raw);
        } catch (err) {
          // Attempt to fix common non-JSON patterns: single quotes and unquoted keys
          try {
            const fixed = raw
              .replace(/'/g, '"')
              .replace(/([\{,\s])([A-Za-z0-9_]+)\s*:/g, '$1"$2":');
            parsed = JSON.parse(fixed);
          } catch (err2) {
            parsed = null;
          }
        }
      } else if (typeof raw === 'object' && raw !== null) {
        parsed = raw;
      }

      if (parsed) {
        if (parsed.tagName !== undefined) setSettingTagName(parsed.tagName);
        if (parsed.tagColor !== undefined) setSettingTagColor(parsed.tagColor);
      }
    }
  }, [shopTagSetting]);

  const _getShopTag = async () => {
    await getShopTagSetting({
      variables: {
        where: {
          shop: SHOP_ID,
        },
        orderBy: "createdAt_ASC"
      },
    });
  }

  const _getUserConfirms = async () => {
    let _shopId = localStorage.getItem("SHOP");

    try {
      let _where = {
        shop: SHOP_ID || _shopId,
        // isDeleted: false
      }

      if (!_.isEmpty(name)) {
        _where = {
          ..._where,
          name: name
        }
      }

      if (status === "active") {
        _where = {
          ..._where,
          isBlocked: false
        }
      }
      if (status === "blocked") {
        _where = {
          ..._where,
          isBlocked: true
        }
      }

      await getUserConfirmData({
        variables: {
          where: _where,
        },
      });
    } catch (error) {
      console.log("error: ", error)
    }


  }


  const getSeletedUser = async (user) => {
    if (selectedIds?.length > 0) {
      const _checkProduct = selectedIds.filter((id) => id == user.id);
      if (_checkProduct?.length > 0) {
        const _checkProduct2 = selectedIds.filter((id) => id != user.id);
        setSelectedIds(_checkProduct2);
      } else {
        const _selectedIds = [...selectedIds, user.id];
        setSelectedIds(_selectedIds);
      }
    } else {
      setSelectedIds([user.id]);
    }


  };


  const onBlockUserCF = async () => {
    try {
      if (loadingUpdateUserConfirm) return;
      const req = await updateUserConfirm({
        variables: {
          where: {
            id_in: selectedIds,
          },
          data: {
            isBlocked: true,
          },
        },
      });
      if (req?.data?.updateUserConfirm?.message === "COMPLETED_UPDATE_USER") {
        _getUserConfirms()
        setIsSelectAll()
        setSelectedIds()
      }

    } catch (error) {
      console.log("error: ", error)
    }



  };

  const onUnBlockUserCF = async () => {
    try {
      if (loadingUpdateUserConfirm) return;
      const req = await updateUserConfirm({
        variables: {
          where: {
            id_in: selectedIds,
          },
          data: {
            isBlocked: false,
          },
        },
      });
      if (req?.data?.updateUserConfirm?.message === "COMPLETED_UPDATE_USER") {
        _getUserConfirms()
        setIsSelectAll()
        setSelectedIds()
      }
    } catch (error) {
      console.log("error: ", error)
    }


  };

  const onUpdateUserTag = async () => {
    console.log("on update tag user")

    let _dataForUpdate = [];

    let userTags = [];
    for (var i = 0; i < enrollTagName.length; i++) {
      userTags.push({ name: enrollTagName[i], color: enrollTagColor[i] });
    }

    let _userList = [...userList];
    for (var i = 0; i < selectedIds.length; i++) {
      _dataForUpdate.push(userList[selectedIds[i]]);
      _userList[selectedIds[i]].tags = JSON.stringify(userTags);
    }

    if (_dataForUpdate.length > 0) {
      setShowUpdateTags(false);
      setLoading(true);
      for (var i = 0; i < _dataForUpdate.length; i++) {
        const dataTags = JSON.stringify(userTags);
        await updateUserConfirm({
          variables: {
            where: {
              id: _dataForUpdate[i]?.id,
            },
            data: {
              tags: dataTags,
            },
          },
        });
      }
      setLoading(false);
    }
    setUserList(_userList);
    setShowUpdateTags(false);
    setSelectedColors([]);
    setEnrollTagColor([]);
    setEnrollTagName([]);
  };

  const handleSelectColor = (name, color, index) => {
    if (selectedColors?.length > 0) {
      const checkSelectedColors = selectedColors?.filter(
        (item) => item === index
      );
      if (checkSelectedColors.length > 0) {
        const unCheckSelectedColors = selectedColors?.filter(
          (item) => item != index
        );
        const unCheckName = enrollTagName?.filter((item) => item != name);
        const unCheckColor = enrollTagColor?.filter((item) => item != color);
        setSelectedColors([...unCheckSelectedColors]);
        setEnrollTagName([...unCheckName]);
        setEnrollTagColor([...unCheckColor]);
      } else {
        const _selectedColors = [...selectedColors, index];
        const _name = [...enrollTagName, name];
        const _color = [...enrollTagColor, color];
        setSelectedColors(_selectedColors);
        setEnrollTagName(_name);
        setEnrollTagColor(_color);
      }
    } else {
      const _selectedColors = [index];
      const _name = [name];
      const _color = [color];
      setSelectedColors(_selectedColors);
      setEnrollTagName(_name);
      setEnrollTagColor(_color);
    }
  };

  const checkMarkTag = (index) => {
    const checkSelectedColors = selectedColors?.filter(
      (item) => item === index
    );
    if (checkSelectedColors.length > 0) {
      return true;
    } else {
      return false;
    }
  };
 

  return (
    <div>

      <div>
        <div style={{ height: 10 }} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 0,
          }}
        >
          <h3 style={{ color: "#616161" }}>
            <FontAwesomeIcon
              icon={faUsers}
              style={{
                color: "#616161",
                margin: 0,
                marginRight: 8,
              }}
            />
            ຈັດການລູກຄ້າຊີເອຟ
          </h3>
        </div>
        <p
          style={{
            fontSize: 14,
            color: "#616161",
            margin: 0,
            paddingRight: 20,
            paddingLeft: 0,
          }}
          className="text-left"
        >
          ຈັດການລູກຄ້າທີ່ເຄີຍຊື້ສິນຄ້ານໍາຮ້ານ ຈໍາແນກປະເພດລູກຄ້າ ແລະ
          ບ໊ອກລູກຄ້າຜູ້ທີ່ກໍ່ກວນ ຫຼື ບໍ່ປະສົງດີຕໍ່ຮ້ານ
        </p>
        <div style={{ height: 20 }} />
        <div
          style={{
            background: "#eee",
            borderRadius: 5,
            padding: 15,
            margin: 0,
          }}
          className="column"
        >
          <div className="row">
            <div className={`${width <455 ? 'col-6':'col-9'}`}>
              <label>ຄົ້ນຫາຕາມຄໍາສັບ</label>
              <input
                type="text"
                className="form-control"
                placeholder="ຄົ້ນຫາຕາມຄໍາສັບ . . . . ."
                value={name}
                onChange={(e) => setName(e?.target?.value)}
              ></input>
            </div> 
            <div className={`${width <455 ? 'col-6':'col-3'}`}>
              <label>ເລືອກສະຖານະ</label>
              <Form.Control as="select" onChange={(e) => setStatus(e?.target?.value)} name="selectStatus" custom>
                <option value="">ທັງໝົດ</option>
                <option value="active">Active</option>
                <option value="blocked">Blocked</option>
              </Form.Control>

            </div>
          </div>
          <div style={{ height: 10 }} />
          <div className={`${width <632 ? '':'row'}`} style={{ margin: 0, display: 'flex', justifyContent: 'end', gap: width <356 ? 4 : 10 }}>
            {/* <button
              className="btn btn-app hoverme col-md-2 col-3"
              style={{
                float: "left",
                background: COLOR_APP,
                color: "#fff",
                width: "100%",
              }}
              onClick={() =>
                selectedIds.length > 0
                  ? setShowUpdateTags(true)
                  : addToast(`ກະລຸນາເລືອກ User ກ່ອນ`, {
                    appearance: "error",
                    autoDismiss: true,
                  })
              }
            >
              <FontAwesomeIcon icon={faFileAlt} /> ອັບເດດແທັກ
            </button> */}
            <button
              className="btn btn-app hoverme col-md-2"
              style={{
                float: "left",
                marginLeft: width < 632 ? 0 : 8,
                background: "red",
                color: "#fff",
                width: width < 632 ? "100%" : "150px",
              }}
              onClick={() =>
                selectedIds.length > 0
                  ? (addToast(
                    <div>
                      <div>
                        <b>ສຳເລັດການ Block</b>
                      </div>
                      <div>
                        ບຸກຄົນນີ້ຈະບໍ່ສາມາດ Comment ເຂົ້າມາໃນຮ້ານເຈົ້າໄດ້ອີກ
                      </div>
                    </div>,
                    {
                      appearance: "success",
                      autoDismiss: true,
                    }
                  ),
                    onBlockUserCF())
                  :
                  addToast(`ກະລຸນາເລືອກ User ກ່ອນ`, {
                    appearance: "error",
                    autoDismiss: true,
                  })
              }
            >
              <FontAwesomeIcon icon={faBan} /> Block User
            </button>
            <button
              className="btn btn-app hoverme col-md-2"
              style={{
                float: "left",
                marginLeft: 8,
                background: "green",
                color: "#fff",
                width: width < 632 ? "100%" : "200px",
              }}
              onClick={async () =>
                selectedIds.length > 0
                  ? (addToast(
                    <div>
                      <div>
                        <b>ສຳເລັດການປົດ Block</b>
                      </div>
                      <div>
                        ບຸກຄົນນີ້ສາມາດ Comment ເຂົ້າມາໃນຮ້ານເຈົ້າໄດ້ແລ້ວ
                      </div>
                    </div>,
                    {
                      appearance: "success",
                      autoDismiss: true,
                    }
                  ),
                    onUnBlockUserCF())
                  :
                  addToast(`ກະລຸນາເລືອກ User ກ່ອນ`, {
                    appearance: "error",
                    autoDismiss: true,
                  })
              }
            >
              <FontAwesomeIcon icon={faShieldAlt} /> Unblock User
            </button>
          </div>
        </div>

        <div style={{ height: 20 }} />
                {loadingQueryUser ? (
              <LoadingSpinner />
            ) : (
              <Table
                responsive
              >
                <thead>
                  <tr>
                    <th style={{ width: 5, borderBottom: 'none' }}>
                      <Form.Check disabled type="checkbox" inline style={{ textAlign: 'center', alignItems: 'center' }} />
                    </th>
                    <th style={{ borderBottom: 'none' }}>ລ/ດ</th>
                    <th style={{ borderBottom: 'none' }}>ຊື່ລູກຄ້າ</th>
                    <th style={{ borderBottom: 'none' }}>ເບີໂທ</th>
                    <th style={{ borderBottom: 'none' }}>ທີ່ຢູ່</th>
                    <th style={{ borderBottom: 'none' }}>
                      ສະຖານະ
                    </th>
                  </tr>
                </thead>

                {userList?.length > 0 ? (
                  <tbody>
                    {userList?.map((user, index) => (
                      <tr
                        key={index}
                        className="hoverme"
                        onClick={() => setSelectedUser(user)}
                      >
                        <td>
                          {isSelectAll ? (
                            <Form.Check
                              type="checkbox"
                              checked={true}
                              disabled
                            />
                          ) : (
                            <Form.Check
                              type="checkbox"
                              onClick={() => getSeletedUser(user)}
                            />
                          )}
                        </td>
                        <td>{index + 1}</td>
                        <td>{user?.name}</td>
                        <td>{user?.phone ?? ""}</td>
                        <td>{user?.addressCF ?? ""}</td>
                        <td>
                          <div style={{ color: user?.isBlocked ? "red" : "green", border: user?.isBlocked ? "1px solid red" : "1px solid green" }} className="status">{user?.isBlocked ? "Blocked" : "Active"}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={6}>
                        <EmptyComponent title={"ຍັງບໍ່ມີລາຍການຜູ້ຊື້ສິນຄ້າເທື່ອ"} />
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            )}
      </div>

      <Modal
        show={showUpdateTags}
        onHide={() => setShowUpdateTags(false)}
        size={"lg"}
      >
        <Modal.Header closeButton>
          <h3>ເລືອກແທັກ</h3>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <ListGroup>
            {settingTagName?.length > 0 ? (
              <div className="col-12 d-flex flex-row flex-wrap justify-content-center">
                {settingTagName.map((item, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() =>
                        handleSelectColor(item, settingTagColor[index], index)
                      }
                      style={{
                        background: settingTagColor[index],
                        color: "#fff",
                        paddingLeft: 18,
                        paddingRight: 18,
                        paddingTop: 12,
                        paddingBottom: 12,
                        minWidth: 100,
                        borderRadius: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: 6,
                        cursor: "pointer",
                        borderTop: checkMarkTag(index)
                          ? "4px solid " + COLOR_APP
                          : "0px solid " + COLOR_APP,
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: 16 }}>
                        {item}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ margin: 18 }}>
                <h4 style={{ color: "grey" }}>
                  ຍັງບໍ່ໄດ້ທັ້ງຄ່າແທັກ (ໄປທີ່ ຕັ້ງຄ່າ {">"} ຕັ້ງຄ້າແທັກ)
                </h4>
              </div>
            )}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="outline-dark"
            className="btn btn-app hoverme"
            style={{ width: 150 }}
            onClick={() => setShowUpdateTags(false)}
          >
            ກັບຄືນ
          </Button>
          <div style={{ width: 24 }} />
          <button
            className="btn btn-app hoverme"
            style={{
              float: "left",
              background: COLOR_APP,
              color: "#fff",
              width: 150,
            }}
            onClick={() => onUpdateUserTag()}
          >
            ອັບເດດ
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showMessengerModal}
        onHide={() => setShowMessengerModal(false)}
      >
        <Modal.Header closeButton>
          <div style={{ textAlign: "center" }}>
            <div>ຕິດຕໍ່ຫາລູກຄ້າຜ່ານທ່າງ Facebook Messenger </div>
            <div style={{ color: "red" }}></div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <UserCFMessenger
            userConfirm={selectedUser}
            closeMessengerModal={() => setShowMessengerModal(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UsersCF;
